import React, {memo} from 'react';
import {View, Text, StyleSheet} from 'react-native';
import AVText from '../../elements/AVText';
import AVFormattedCurrency from '../../elements/AVFormattedCurrency';
import {isFreeText, getModifierName, toNum} from './utils/promo';
import Localized from 'src/constants/AppStrings';
import AccountStore from 'src/stores/AccountStore';
import Styles from '../../Styles';
import {scanAndPayTemplate as tpl} from './templates/scanandPayThemeHelper';

const {modifierTextsColor, selectedProductsFont, showPlus} = tpl;

export type Modifier = {
  SeqNum?: number;
  SeatNbr?: number;
  Type?: number;
  Price: string | number | null;
  Name?: string;
};

interface Props {
  modifier: Modifier;
  isFirst: boolean;
}

const ModifierLine: React.FC<Props> = ({modifier, isFirst}) => {
  const price = toNum(modifier.Price);
  const free = isFreeText(modifier.SeatNbr, modifier.Type);

  return (
    <View style={tpl.checkoutStyles.rowContainer}>
      <Text
        maxFontSizeMultiplier={Styles.FontSizeMultiplier.maxfm3}
        accessibilityLabel={modifier.Name}
        style={[
          styles.modifierText,
          isFirst ? styles.firstModifier : styles.subsequentModifier,
          free ? styles.freeLine : styles.normalLine,
        ]}
        accessible
        testID="qa_Checkout.Modifier_txt"
        nativeID="qa_Checkout.Modifier_txt"
      >
        {getModifierName(
          modifier.SeatNbr,
          modifier.Name,
          modifier.Type,
          Localized.Labels.message,
        )}
      </Text>

      {!free && price != null && price > 0 && (
        <AVText
          maxFontSizeMultiplier={Styles.FontSizeMultiplier.maxfm3}
          accessibilityLabel={`$${price.toFixed(2)}`}
          style={styles.priceText}
          accessible
          testID="qa_Checkout.ModifierPrice_txt"
          nativeID="qa_Checkout.ModifierPrice_txt"
        >
          {showPlus && '+'}
          <AVFormattedCurrency
            value={price}
            currency={AccountStore.getCurrency()}
            accessible
            testID="qa_Checkout.ModifierPrice_txt"
            nativeID="qa_Checkout.ModifierPrice_txt"
          />
        </AVText>
      )}
    </View>
  );
};

export default memo(ModifierLine);

const styles = StyleSheet.create({
  modifierText: {
    flex: 0.7,
    color: modifierTextsColor,
    marginLeft: Styles.Spacing.m2,
    fontFamily: tpl.textFontFamily,
    fontSize: selectedProductsFont,
  },
  priceText: {
    marginTop: Styles.Spacing.m1,
    fontFamily: tpl.textFontFamily,
    fontWeight: '300',
    flex: 0.4,
    textAlign: 'right',
    color: modifierTextsColor,
  },
  firstModifier: {marginTop: 0},
  subsequentModifier: {marginTop: Styles.Spacing.m1},
  freeLine: {lineHeight: 26},
  normalLine: {lineHeight: 18},
});
